import { render, staticRenderFns } from "./PastPartnerPayout.vue?vue&type=template&id=08cb65a1&scoped=true&"
import script from "./PastPartnerPayout.vue?vue&type=script&lang=js&"
export * from "./PastPartnerPayout.vue?vue&type=script&lang=js&"
import style0 from "./PastPartnerPayout.vue?vue&type=style&index=0&id=08cb65a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb65a1",
  null
  
)

export default component.exports